import React from 'react';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { continueIcon } from '../chatIcons';
import './ContinueButtonBar.css';

export interface ContinueButtonBarProps {
  onContinue: () => void;
  /** defaults to submitDocuments.chat.continue */
  label?: string;
}

const ContinueButtonBar: React.FC<ContinueButtonBarProps> = ({ onContinue, label }) => {
  const { t } = useLanguage();
  const text = label ?? t('submitDocuments.chat.continue');

  return (
    <div className="ff-continue-bar">
      <button type="button" className="ff-continue-bar__btn" onClick={onContinue}>
        <span className="ff-continue-bar__text">{text}</span>
        <span className="ff-continue-bar__arrow-wrap" aria-hidden>
          <img src={continueIcon} alt="" className="ff-continue-bar__arrow" />
        </span>
      </button>
    </div>
  );
};

export default ContinueButtonBar;

